import React, {useState, useEffect, useRef} from 'react'

import {
    Dialog, 
    MenuItem, 
    Button,
    RadioGroup,
    Radio,
    FormControlLabel,
    TextField, 
    Typography, 
    IconButton,
    DialogTitle, 
    DialogContent, 
    DialogActions,
    Stepper,
    Step,
    StepLabel,
    StepContent
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';


// Component styles
import styles from "./styles";
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
const useStyles = makeStyles(styles);

//set input props based on CRM field type

const INPUT_PROPS = {
    date: {type: "date"}, 
    time: {type: "time"}, 
    int: {type: "number"},
    datetime: {type: "datetime-local"},
    string: {type: "text"},
    long: {type: "number"},
    currency: {type: "number", inputProps: {step: "any"}},
    double: {type: "number", inputProps: {step: "any"}},
    email: {type: "email"},
    id: {type: "text"},
    percent: {type: "number", inputProps: {min: "0", max: "100"} },
    phone: {type: "tel"},
    url: {type: "url"},
    textarea: {type: "text", multiline:true},
    picklist: {select: true}
}
      

export default function AutoFieldDialog(props){
    const [stepIndex, setStepIndex] = useState(0);
    const [selectedValue, setSelectedValue] = useState(null);
    const [inputValue, setInputValue] = useState("")
    const classes = useStyles();
    const firstUpdate = useRef(true);


    useEffect(()=>{
        if(firstUpdate.current){
            firstUpdate.current = false;
            return;
        }
        props.setNewField(props.fieldType);
        props.setDialog(false); 
    },[props.activeValue]);
      

    const saveAutoField = (e) => {
        if(!selectedValue)return;
        let pickedField = {...selectedValue};
        pickedField.value = inputValue;
        pickedField.hidden = props.fieldType === "autofields";
        props.addNewField(pickedField);
        setInputValue("");
    }
 
    const renderBasedOnType = () => {
        if(!selectedValue)return;
        if(selectedValue.type === "boolean"){
            return(
                <RadioGroup style={{width: 300}} onChange={(e) => setInputValue(e.target.value)} value={inputValue}>
                    <FormControlLabel value="true" control={<Radio />} label="True" />
                    <FormControlLabel value="false" control={<Radio />} label="False" />
                </RadioGroup>
                )
        }else{
            return( 
                <TextField {...INPUT_PROPS[selectedValue.type]} onChange={(e) => setInputValue(e.target.value)} value={inputValue} style={{width: 300}} variant="outlined">
                     {selectedValue?.picklistValues&&selectedValue.picklistValues.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
                </TextField>
            )
        }
    }

    return(
        <>
        <Dialog open={props.showDialog}>
            <DialogTitle disableTypography>
                <Typography variant="h5">{props.dialogTitle}</Typography>
                <IconButton onClick={() => props.setDialog(false)} style={{position:"absolute",top:5,right:5}}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Stepper activeStep={stepIndex} orientation="vertical">
                    <Step>
                        <StepLabel className={classes.stepLabelCustom}>Enter Field Name</StepLabel>
                        <StepContent className={classes.stepContentCustom}>
                            <Autocomplete
                                options={props.metafields.filter(item => item.type !== "reference")}//prevent auto updating reference types for now
                                style={{width: 300}}
                                onChange={
                                    (e, value) => {
                                        setSelectedValue(value);
                                        setStepIndex(prevState => (prevState+1));
                                        }}
                                getOptionLabel={(option) => (`${option.label}`)}
                                renderInput={(params) => <TextField {...params} variant="outlined" />}
                            />
                        </StepContent>
                    </Step>
                    <Step>
                        {props.fieldType === "autofields"?
                        <StepLabel className={classes.stepLabelCustom}>Update {selectedValue?<span className={classes.pickedOption}>{selectedValue.label}</span>:"Field"} To Value:<span className={classes.pickedOption}>{/* {selectedField} */}</span></StepLabel>
                        :
                        <StepLabel className={classes.stepLabelCustom}>Set optional default value </StepLabel>
                        }
                        <StepContent className={classes.stepContentCustom}>
                            {renderBasedOnType()}
                        </StepContent>
                    </Step>
                </Stepper>
            </DialogContent>
            <DialogActions>
                <Button disabled={!inputValue && props.fieldType === "autofields"} onClick={ (e) => saveAutoField(e)}>Save</Button>
            </DialogActions>
        </Dialog>
        </>
    )
}